export default __webpack_public_path__ + "static/media/openTable.e061da0e.svg";